import { isAfter } from 'date-fns';
import { TFunction, useTranslation } from 'next-i18next';
import React from 'react';
import Countdown from 'react-countdown';
import { shallowEqual } from 'react-redux';
import useMobileView from '../../../../../hooks/useMobileView';
import { usePages } from '../../../../../hooks/usePages';
import { CountdownComponentInterface, UiComponentElementInterface } from '../../../../../interfaces/pagebuilder';
import { useSelector } from '../../../../../reduxToolkit/typedRedux';
import EmptyComponent from '../../../pageBuilder/EmptyComponent';
const CountdownComponent = ({ uiComponent }: UiComponentElementInterface<CountdownComponentInterface>) => {
  const { event } = useSelector(({ common: { event } }) => ({ event }), shallowEqual);
  const pages = useSelector((state) => state.common.pages);

  const { isMobileView } = useMobileView();

  const { t } = useTranslation();
  const { switchPageWithPageData, findPageById } = usePages();

  const endTime = uiComponent?.customTime ?? event?.datetime_start;
  const timeOver: boolean = isAfter(Date.now(), new Date(endTime || ''));

  function redirect() {
    if (!endTime) return;
    if (uiComponent?.postaction === 'redirect' && uiComponent?.isInternalRoute) {
      if (!uiComponent.selectedPage) return;
      const page = findPageById(uiComponent.selectedPage, pages);
      page && switchPageWithPageData(page, event!.slug, false, undefined, true);
      return;
    }
    if (uiComponent?.postaction === 'redirect' && uiComponent.redirectLink) {
      window.location.href = uiComponent.redirectLink;
      return;
    }
    if (uiComponent?.postaction === 'none') {
      return;
    }
  }

  const countdownUnit = (value: number, unit: string) => {
    return (
      <div className="flex flex-col">
        <div
          className={`text-center w-full`}
          style={{
            fontVariantNumeric: 'tabular-nums',
            fontSize: isMobileView() ? '3em' : `${uiComponent?.customStyling?.countdownTextSize ?? 5}em`,
            margin: 0,
          }}>
          {value < 10 ? `0${value}` : value}
        </div>
        <div
          className="w-full text-center"
          style={{
            fontVariantNumeric: 'tabular-nums',
            fontSize: isMobileView() ? '1em' : `${uiComponent?.customStyling?.countdownTextSize ? uiComponent?.customStyling?.countdownTextSize / 3 : 2}em`,
            margin: 0,
          }}>
          {unit}
        </div>
      </div>
    );
  };

  return (
    <>
      {endTime && !timeOver ? (
        <div
          className={`w-full `}
          style={{
            color: uiComponent?.styling?.textColor || '#000',
          }}>
          <div className="font-bold transition-all">
            <Countdown
              date={endTime}
              onComplete={redirect}
              renderer={({ days, hours, minutes, seconds }) => (
                <div className={uiComponent?.customStyling.fullWidth ? 'flex flex-row justify-between' : 'grid grid-cols-4 w-full place-items-center'}>
                  {countdownUnit(days, t('event:countdown.days'))}
                  {countdownUnit(hours, t('event:countdown.hours'))}
                  {countdownUnit(minutes, t('event:countdown.minutes'))}
                  {countdownUnit(seconds, t('event:countdown.seconds'))}
                </div>
              )}
            />
          </div>
        </div>
      ) : (
        <EmptyComponent componentName={t('pagebuilder:countdown')} />
      )}
    </>
  );
};

export default CountdownComponent;
